import { Pipe, PipeTransform } from '@angular/core';

import { isNight } from '../constants/constants';

@Pipe({ name: 'isNight' })
export class IsNightPipe implements PipeTransform {
  transform(dtg: string) {
    return isNight(dtg);
  }
}
